import styled, { keyframes } from 'styled-components';
import { SIGNALS_FONT_FAMILY } from '../theme/constants';

// Phase 1 placeholder for merchants without the feature flag. This is
// intentionally text-only — the richer "preview mode" treatment with sample
// cards lands in Phase 2 once the marketing copy is finalised. The page
// still gives a sense of what's coming and matches the dashboard's
// typographic voice.
export const SignalsComingSoon = () => (
  <Wrapper>
    <Glow />
    <Center>
      <Eyebrow>Sapaad Signals</Eyebrow>
      <Heading>Coming soon</Heading>
      <Tagline>
        A live operations cockpit that surfaces the things that need your
        attention — sales drops, void spikes, stockouts and more — before
        they cost you the day.
      </Tagline>
      <Footnote>You'll see this page light up the moment Signals is enabled for your account.</Footnote>
    </Center>
  </Wrapper>
);

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const drift = keyframes`
  0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.55; }
  50%      { transform: translate(-50%, -50%) scale(1.08); opacity: 0.75; }
`;

const Wrapper = styled.div`
  position: relative;
  min-height: calc(100vh - 60px);
  background: ${({ theme }) => theme.signals.page_bg};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 80px 24px;
  font-family: ${SIGNALS_FONT_FAMILY};
`;

// Soft radial glow tinted with the brand orange — gives the otherwise spare
// page some life without requiring any imagery.
const Glow = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 720px;
  height: 720px;
  border-radius: 50%;
  background: radial-gradient(
    closest-side,
    ${({ theme }) => theme.signals.neutral_tint} 0%,
    transparent 70%
  );
  pointer-events: none;
  animation: ${drift} 9s ease-in-out infinite;
`;

const Center = styled.div`
  position: relative;
  max-width: 560px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 18px;
  animation: ${fadeIn} 0.6s ease-out both;
`;

const Eyebrow = styled.div`
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.signals.text_muted};
`;

const Heading = styled.h1`
  margin: 0;
  font-size: 56px;
  line-height: 1.05;
  font-weight: 800;
  letter-spacing: -0.5px;
  color: ${({ theme }) => theme.signals.text_primary};

  @media (max-width: 600px) {
    font-size: 40px;
  }
`;

const Tagline = styled.p`
  margin: 0;
  font-size: 17px;
  line-height: 1.55;
  color: ${({ theme }) => theme.signals.text_secondary};
`;

const Footnote = styled.p`
  margin: 12px 0 0;
  font-size: 13px;
  color: ${({ theme }) => theme.signals.text_muted};
`;
